import { render, staticRenderFns } from "./PromotionZone.vue?vue&type=template&id=4c9a70f4&scoped=true"
import script from "./PromotionZone.vue?vue&type=script&lang=js"
export * from "./PromotionZone.vue?vue&type=script&lang=js"
import style0 from "./PromotionZone.vue?vue&type=style&index=0&id=4c9a70f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a70f4",
  null
  
)

export default component.exports